import { render, staticRenderFns } from "./no-results-suggestions.vue?vue&type=template&id=dbcf7494"
import script from "./no-results-suggestions.vue?vue&type=script&lang=js"
export * from "./no-results-suggestions.vue?vue&type=script&lang=js"
import style0 from "./no-results-suggestions.vue?vue&type=style&index=0&id=dbcf7494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports